// extracted by mini-css-extract-plugin
export var contactHolder = "contact-module--contactHolder--f87fd";
export var contactIconLinks = "contact-module--contactIconLinks--5763f";